import PropTypes from "prop-types"

export const discussionContextPropType = PropTypes.shape({
  resource_id: PropTypes.number,
  cohort_id: PropTypes.number,
  step_id: PropTypes.number,
  completion_id: PropTypes.number
})
